module.exports = __webpack_public_path__ + "img/full5-min.444cf6f9.png";